import Button from "../core/Button";
import GameConfig from "../core/data/GameConfig";
import Strings from "../core/data/Strings";
import { GameObject } from "../core/GameObject";
import ResizableScene from "../core/ResizableScene";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { ItemData } from "../scenes/ShopScene";
import Fonts from "../utils/Fonts";
import LayoutUtils from "../utils/LayoutUtils";
import TweenUtils from "../utils/TweenUtils";

export class StoreItem extends GameObject {

	itemName: string;
	itemData: ItemData;
	fills: Phaser.GameObjects.Image[] = [];
	priceText: Phaser.GameObjects.Text;

	onResize: () => void;

	static ON_BUY_PRESSED = "onBuyPressed";
	icon: Phaser.GameObjects.Image;
	divider: Phaser.GameObjects.Image;
	hand: Phaser.GameObjects.Image;
	btn: Button;
	btnGroup: Phaser.GameObjects.Container;
	bgs: Phaser.GameObjects.Image[];

	constructor(scene: ResizableScene, itemName: string) {
		super(scene);
		this.itemName = itemName;
		this.itemData = GameConfig.get<any>("items")[itemName] as ItemData;

		this.setSize(750, 250);

		const bg = this.addImage("whiteSquare");
		bg.tint = 0x888888;
		bg.alpha = 0.001;
		bg.setSize(this.width, this.height);
		bg.setDisplaySize(this.width, this.height);

		const icon = this.icon = this.addImage("shopItem" + itemName);
		scene.alignIn.LeftCenter(icon, bg, -20, 0);

		const titleHeader = this.addImage("shopItemHeader")
		scene.alignIn.TopLeft(titleHeader, bg, -280, -15);

		const style = {
			fontFamily: Fonts.MaliMediumItalic,
			fontSize: "20px",
			color: "#33261b",
			wordWrap: { width: 350, useAdvancedWrap: true },
			align: "left",
		};

		const str = Strings.get(itemName + "Desc");
		// const nameStrings = Strings.get(itemName).split(/ (.*)/s)
		const nameStr = Strings.get(itemName);
		let acmeIndex = nameStr.indexOf("ACME");
		if (acmeIndex < 0 || acmeIndex == null) acmeIndex = nameStr.indexOf("«АКМЕ»");

		const spaceIndex = nameStr.substring(0, acmeIndex).lastIndexOf(" ");
		const splitIndex = (spaceIndex < 0 || spaceIndex == null) ? acmeIndex : spaceIndex;

		const nameStrings = [nameStr.substring(0, splitIndex), nameStr.substring(splitIndex)];
		const acme = scene.add.text(0, 0, nameStrings[0], {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "27px",
			color: "#fcb415",
		});
		const name = scene.add.text(0, 0, nameStrings[1], {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "27px",
			color: "#f7e0c2"
		});
		const scale = (acme.width + name.width > 330) ? 330 / (acme.width + name.width) : 1;
		acme.scale = scale;
		name.scale = scale;
		acme.setSize(acme.displayWidth, acme.displayHeight);
		name.setSize(name.displayWidth, name.displayHeight);
		const desc = scene.add.text(0, 0, str.toUpperCase(), style);
		this.add([acme, name, desc]);
		scene.alignIn.LeftCenter(acme, titleHeader, -30, 0);
		scene.alignTo.RightCenter(name, acme, 7 * scale, 0);
		scene.alignIn.TopLeft(desc, bg, -298, -83);

		const btnBg = this.addImage("shopItemMeterBacker");
		scene.alignIn.Center(btnBg, bg, 5, 76);

		const bgs: Phaser.GameObjects.Image[] = this.bgs = [];
		for (let i = 0; i < 10; i++) {
			const meterBG = this.addImage("shopItemMeterEmpty");
			bgs.push(meterBG);
			const meterFill = this.addImage("shopItemMeterFull" + this.itemData.color);
			this.fills.push(meterFill);
		}
		LayoutUtils.alignGrid(scene, bgs, bg, 18, 10, 5, 76);
		LayoutUtils.alignGrid(scene, this.fills, bg, 18, 10, 5, 76);

		const buttonGroup = this.btnGroup = scene.add.container();
		this.add(buttonGroup);

		const glow = scene.add.image(0, 0, "shopButtonGlow");
		glow.setVisible(false);
		buttonGroup.add(glow);

		const button = this.btn = scene.add.button(0, 0, "shopBuyBtn", undefined, this.buy, this, false);
		buttonGroup.setSize(button.width, button.height);
		buttonGroup.add(button);
		scene.alignIn.BottomRight(buttonGroup, bg, -85, -12);

		const coinIcon = this.addImage("shopCoin");
		coinIcon.setScale(0.5);
		buttonGroup.add(coinIcon);
		scene.alignIn.LeftCenter(coinIcon, button, -5, -5);

		const priceText = this.priceText = scene.add.text(0, 0, "3", {
			fontFamily: Fonts.LuckiestGuy,
			fontSize: "37px",
			color: "#FBf6e7",
		});
		this.priceText.setOrigin(0.5);
		buttonGroup.add(priceText);

		const divider = this.divider = this.addImage("shopDivider")
		scene.alignIn.BottomCenter(divider, bg, -20, 15);
		this.sendToBack(divider);


		this.onResize = (): void => {
			const level = PlayerData.Instance.saveData.items[itemName];
			// const versionStr = (level > 0) ? Strings.get("ItemVersion").replace("%N", level + "") : "";
			for (let i = 0; i < this.fills.length; i++) {
				this.fills[i].visible = (i < level);
			}
			const price = this.itemData.price[level];
			const canAfford = PlayerData.Instance.saveData.coins >= price;
			this.priceText.setText(price ? "" + price.toLocaleString("en-US") : Strings.get("SoldOut"));
			LayoutUtils.scaleToMaxWidth(this.priceText, 150);
			if (!price) button.disableInteractive();

			const buyable = (price && canAfford);
			button.setTexture(buyable ? "shopBuyBtn" : "shopBuyBtnLocked");

			if(glow.visible != buyable) {
				if(buyable) {
					glow.setAlpha(0);
					this.scene.tweens.add({
						targets: glow,
						duration: 500,
						alpha: 1,
						yoyo: true,
						loop: -1,
						ease: Phaser.Math.Easing.Quadratic.InOut
					});
				}
				else {
					this.scene.tweens.killTweensOf(glow);
				}
			}

			glow.visible = buyable;
			coinIcon.visible = price != null;
			scene.alignIn.Center(priceText, button, 0, -5);
			if(price){
				if(price.toFixed().length >= 4){
					scene.alignIn.Center(priceText, button, 10, -5);
					scene.alignIn.LeftCenter(coinIcon, button, 0, -5);

				}
			}
			if (this.hand) this.hand.setPosition(this.parentContainer.x + this.x + buttonGroup.x, this.parentContainer.y + this.y + buttonGroup.y + 30);
		};

		this.updateLayout();
	}

	updateLayout(): void {	
		this.onResize();
	}

	buy(): void {
		this.emit(StoreItem.ON_BUY_PRESSED, this.itemName);
		// this.updateLayout();
	}

}